/**
 * 全局使用一个$auth.isLogin来控制用户是否登录，watch该变量来控制跳回登录页或首页 √
 * 场景：
 * 初次打开页面、刷新页面（获取token，userinfo，修改isLogin的值）
 * 接口拦截（http.js，401即过期，清除用户信息，修改isLogin）===
 * 登出（清除用户信息，修改isLogin）√
 * 登入（保存用户信息，修改isLogin）√
 */
// import iview from '_u/iview'
// import { Message, Spin } from 'iview';
import { Message, Loading } from 'element-ui';
import qs from 'qs';
import { Base64 } from 'js-base64';
import Cookies from 'js-cookie';
import api from '../api';
import router from '../router';
import ro from 'element-ui/src/locale/lang/ro';
import el from 'element-ui/src/locale/lang/el';
/** 'token' 转码 base64 */
const base64token = Base64.encode('token');

/** 配置项 */
const config = {
  client_id: 'gsl_front_end',
  grant_type: 'password',
};

let loading = Loading.service({
  fullscreen: true,
  background: 'rgba(0, 0, 0, 0.4)',
});

class Auth {
  /** 构造函数 */
  constructor() {
    this.userInfo = null; // 用户信息
    this.token = null; // token
    this.isLogin = true; // 用户是否已登录
    this.Vue = null; // Vue构造函数
  }

  /** 获取token，刷新token */
  getToken(username, pwd) {
    return new Promise((resolve, reject) => {
      api.login
        .getToken(
          qs.stringify({
            username: username,
            password: Base64.decode(pwd),
            client_id: config.client_id,
            // client_secret: '111fbe04-0192-402b-b0c6-36f5f2cc6119',
            grant_type: config.grant_type,
          }),
          null,
          {
            tipShow: false,
          },
        )
        .then((res) => {
          console.log('token获取成功', res);
          this.token = res.data.access_token; // token
          // this.getUserInfo();
          let expiredTime = new Date().getTime() + 60 * 60 * 1000;
          Message.success('登录成功！');

          // 登录成功之后，在localStorage上保存用户登录信息
          // localStorage.setItem(base64token, this.token);
          Cookies.set(base64token, this.token);
          sessionStorage.setItem('expiredTime', expiredTime);

          resolve(res);
        })
        .catch((err) => {
          if (err.status == 400) {
            Message.error('该用户已被禁用,请联系管理员');
          } else {
            Message.error('账号或密码错误');
          }
          reject(err);
        });
    });
  }

  /** 刷新token */
  refreshToken() {}

  /** 获取用户信息 */
  getUserInfo() {
    return new Promise((resolve, reject) => {
      api.login
        .getUserInfo()
        .then((res) => {
          this.userInfo = res.data;
          localStorage.setItem('userInfo', JSON.stringify(res.data));
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  /** 用户登录页登录 */
  login(username, pwd) {
    if (!username || !pwd) {
      Message.error('账号或密码不能为空！');
    } else {
      loading;
      this.getToken(username, pwd)
        .then(async (res) => {
          this.isLogin = true;
          this.handleRedirect();
          localStorage.setItem('username', username);
          this.Vue.prototype.$log.addItem('用户登录', '登录');
        })
        .catch((err) => {})
        .finally(() => {
          loading.close();
        });
    }
  }

  /** 用户登出，清除用户信息，并跳转登录页 */
  logout() {
    this.isLogin = false; // 用户是否已登录
    this.userInfo = null; // 用户信息
    this.token = null; // token
    Cookies.remove(base64token);
    sessionStorage.clear();
    localStorage.clear();
    const tmp = window.location.hash;
    let redirect;
    if (tmp.indexOf('redirect=') >= 0) {
      redirect = tmp.split('redirect=')[1];
    } else {
      redirect = tmp.split('#/')[1];
    }
    if (redirect && redirect !== 'login') router.push(`/login?redirect=${redirect}`);
    else router.push('/login');
    console.log('退出登录');
  }

  /** 重定向 */
  handleRedirect() {
    console.group('handleRedirect');
    /** 延迟跳转，否则登录页刷新会跳转到首页 */
    setTimeout(() => {
      const tmp = window.location.hash;
      let redirect;
      if (tmp.indexOf('redirect=') >= 0) {
        redirect = tmp.split('redirect=')[1];
      } else {
        redirect = tmp.split('#/')[1];
      }
      console.log(redirect);
      if (this.isLogin) {
        if (redirect && redirect !== 'login') router.push('/' + redirect);
        else router.push('/gather');
      } else {
        if (redirect && redirect !== 'login') router.push(`/login?redirect=${redirect}`);
        else router.push('/login');
      }
    }, 200);

    console.groupEnd('handleRedirect');
  }

  /** 初始化监听事件 */
  initEvent() {
    if (!this.Vue) return;

    const vm = new this.Vue();
    /** immediate: true */
    this.handleRedirect();

    /** watch auth.isLogin */
    vm.$watch('$auth.isLogin', () => {
      this.handleRedirect();
    });

    /** watch hash or route.path */
    window.addEventListener('hashchange', () => {
      this.handleRedirect();
    });
  }

  /** 是否有权限 */
  hasPermission(code, needOnlyOne) {
    /** 未设置权限码 */
    if (!code) {
      return true;
    }

    let permissionList = this.userInfo && this.userInfo.resource;
    // console.log(permissionList, '-p')
    if (!permissionList) {
      return false;
    }

    let hasPermission = false;

    // code 为数组时
    if (Array.isArray(code)) {
      if (needOnlyOne) {
        for (let item of code) {
          if (this.hasPermission(item)) {
            hasPermission = true;
            break;
          }
        }
      } else {
        hasPermission = true;
        for (let item of code) {
          if (!this.hasPermission(item)) {
            hasPermission = false;
            break;
          }
        }
      }
    }

    /** 有权限码 */
    hasPermission = permissionList.includes(code);

    return hasPermission;
  }
}

/** 注册Auth */
Auth.install = function (Vue) {
  let auth = Vue.observable(new Auth());

  auth.Vue = Vue;

  /** 将$auth变成响应式 */
  Vue.prototype.$auth = auth;

  /** 初始化监听事件 */
  auth.initEvent();

  /** 先用localStorage中拿token */
  let token = Cookies.get(base64token),
    expiredTime = sessionStorage.getItem('expiredTime');

  let { meta } = { ...router.currentRoute };
  if (meta.noCheck) return;

  // 登录过期
  if (new Date().getTime() >= expiredTime) {
    sessionStorage.clear();
    Cookies.remove(base64token);
    token = null;
  }

  if (token) {
    auth.token = token;
    Cookies.set(base64token, token, { domain: '.datanas.cn' });
    // sessionStorage.setItem(base64token, token);
    // auth.getUserInfo().then(() => {
    //   console.log('获取用户信息成功');
    //   auth.isLogin = true;
    //   auth.handleRedirect();
    // }).catch(err => {
    //   console.log('获取用户信息失败: ', err);
    //   auth.logout();
    // });
  } else {
    auth.logout();
  }
};

export default Auth;
